import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpoint.update.error': {
    defaultMessage: 'Failed to update checkpoint',
    id: 'checkpoint.update.error'
  },
  'checkpoint.update.pageTitle': {
    defaultMessage: 'Update Checkpoint',
    id: 'checkpoint.update.pageTitle'
  },
  'checkpoint.update.success': {
    defaultMessage: 'Updated checkpoint',
    id: 'checkpoint.update.success'
  }
});
